import axios from 'axios';

import { GenericDetailedError } from '~/errors/GenericDetailedError';
import { TPSServerError } from '~/errors/TPSServerError';
import type { ApiExportsEntry, NewSubmissionArgs } from '~/types/api-types';

class SubmissionsApiClass {
  async delete(exportId: number) {
    try {
      await axios.delete(`/api/submissions/${exportId}`);
    } catch (error: any) {
      if (error instanceof TPSServerError) {
        switch (error.errorCode) {
          case 117:
            throw new GenericDetailedError('Det gick inte att ta bort exporten', 'Exporten kunde inte hittas.');
          default:
            throw new GenericDetailedError('Oväntat serverfel', error.message);
        }
      } else {
        throw new GenericDetailedError('Oväntat fel', error.message);
      }
    }
  }

  async create(args: NewSubmissionArgs) {
    try {
      await axios.post('/api/submissions', args);
    } catch (error: any) {
      if (error instanceof TPSServerError) {
        switch (error.errorCode) {
          case 115:
            throw new GenericDetailedError('Det gick inte att starta exporten', 'Versionen existerar inte.');
          case 116:
            throw new GenericDetailedError('Det gick inte att starta exporten', 'Typen existerar inte.');
          default:
            throw new GenericDetailedError('Oväntat serverfel', error.message);
        }
      } else {
        throw new GenericDetailedError('Oväntat fel', error.message);
      }
    }
  }

  async getAll(): Promise<ApiExportsEntry[]> {
    try {
      return (await axios.get<ApiExportsEntry[]>('/api/submissions')).data;
    } catch (error: any) {
      if (error instanceof TPSServerError) {
        switch (error.errorCode) {
          default:
            throw new GenericDetailedError('Oväntat serverfel', error.message);
        }
      } else {
        throw new GenericDetailedError('Oväntat fel', error.message);
      }
    }
  }
}

export const SubmissionsApi = new SubmissionsApiClass();
